export class GA {
    /**
     * Asynchronně hashuje textový řetězec pomocí algoritmu SHA-256.
     * @param {string} text Řetězec k zahashování.
     * @returns {Promise<string|null>} Promise, která se resolvne s hexadecimálním řetězcem hashe, nebo null.
     */ 
    static async sha256(text) {
        // Zkontroluje, zda je vstup platný textový řetězec
        if (!text || typeof text !== 'string') {
            return null;
        }
        try {
            // Převede text na pole bajtů (UTF-8) a ořízne mezery, převede na malá písmena
            const encoder = new TextEncoder();
            const data = encoder.encode(text.trim().toLowerCase());

            // Provede hashování pomocí SubtleCrypto API
            const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);

            // Převede výsledek na pole 8-bitových celých čísel
            const hashArray = Array.from(new Uint8Array(hashBuffer));

            // Převede každý bajt na hexadecimální reprezentaci a spojí je do jednoho řetězce
            return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        } catch (error) {
//            console.error('SHA-256 hashing failed:', error);
            return null;
        }
    }
    
    static utmPetitionSignup() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'petitionSignup'
        })
    }

    static utmDonate(eventAction, eventValue) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event' : 'donateForm',
            'eventCategory' : 'Donation',
            'eventAction' : eventAction,
            'eventLabel': 'CZK',
            'eventValue': eventValue
        })
    }

    static utmShareClose() {
        dataLayer.push({
            'event' : 'engagementActivity',
            'eventCategory' : 'shareClose'
        });
    }

    static utmSharing(eventAction) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'engagementActivity',
            'eventCategory': 'share',
            'eventAction': eventAction
        });
    }

    // ----------------------------------------- Sign to donate --------------------------------------- \\

    static utmSignToDonateInit() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'virtualLocation': document.location.protocol + '//' +
                document.location.hostname +
                document.location.pathname +
                document.location.search
        });
    }

    static utmSignToDonatePetitionThankYouInit() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'virtualPageview',
            'pageTitle': 'Thank you',
            'pageUrl': document.location.protocol + '//' +
                document.location.hostname +
                document.location.pathname +
                document.location.search
        });
    }

    static utmSignToDonateSharingInit() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'virtualPageview',
            'pageTitle': 'Share',
            'pageUrl': document.location.protocol + '//' +
                document.location.hostname +
                document.location.pathname +
                document.location.search
        });
    }

    static utmSignToDonateDonationInit() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'virtualPageview',
            'pageTitle': 'Donate',
            'pageUrl': document.location.protocol + '//' +
                document.location.hostname +
                document.location.pathname +
                document.location.search
        });
    }

}